/**
 * FE-derived user helpers for the Users table (the backend does NOT return
 * `initials`/`avatarColor` — see §6.1 BE notes). Initials from the name, and a
 * deterministic per-user gradient so the same user always gets the same color.
 * Pure functions (not a component) — hence the camelCase `.ts` filename.
 */

export function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("");
}

function hashHue(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return h % 360;
}

/** Stable diagonal gradient derived from a seed (user id or name). */
export function avatarGradient(seed: string): string {
  const hue = hashHue(seed);
  return `linear-gradient(145deg, hsl(${hue} 68% 55%), hsl(${(hue + 40) % 360} 68% 45%))`;
}
